import { ContainerIterator } from "../../ContainerBase";
import { throwIteratorAccessError } from "../../../utils/throwError";
class TreeIterator extends ContainerIterator {
    /**
     * @internal
     */
    constructor(_node, _header, iteratorType) {
        super(iteratorType);
        this._node = _node;
        this._header = _header;
        if (this.iteratorType === 0 /* IteratorType.NORMAL */) {
            this.pre = function () {
                if (this._node === this._header._left) {
                    throwIteratorAccessError();
                }
                this._node = this._node._pre();
                return this;
            };
            this.next = function () {
                if (this._node === this._header) {
                    throwIteratorAccessError();
                }
                this._node = this._node._next();
                return this;
            };
        }
        else {
            this.pre = function () {
                if (this._node === this._header._right) {
                    throwIteratorAccessError();
                }
                this._node = this._node._next();
                return this;
            };
            this.next = function () {
                if (this._node === this._header) {
                    throwIteratorAccessError();
                }
                this._node = this._node._pre();
                return this;
            };
        }
    }
    /**
     * @description Get the sequential index of the iterator in the tree container.<br/>
     *              <strong>Note:</strong>
     *              This function only takes effect when the specified tree container `enableIndex = true`.
     * @returns The index subscript of the node in the tree.
     * @example
     * const st = new OrderedSet([1, 2, 3], true);
     * console.log(st.begin().next().index);  // 1
     */
    get index() {
        let _node = this._node;
        const root = this._header._parent;
        if (_node === this._header) {
            if (root) {
                return root._subTreeSize - 1;
            }
            return 0;
        }
        let index = 0;
        if (_node._left) {
            index += _node._left._subTreeSize;
        }
        while (_node !== root) {
            const _parent = _node._parent;
            if (_node === _parent._right) {
                index += 1;
                if (_parent._left) {
                    index += _parent._left._subTreeSize;
                }
            }
            _node = _parent;
        }
        return index;
    }
}
export default TreeIterator;
